// services/product.ts
import { Paginate, Product, SuccessResponse } from "interfaces";
import request from "./request";

const productService = {
  // liste
  getAll: (params?: any): Promise<Paginate<Product>> =>
    request.get(`/rest/products/paginate`, { params }),

  getAllShopProducts: (id: number, params?: any) =>
    request.get(`/rest/shops/${id}/products`, { params }),

  search: (params: any): Promise<Paginate<Product>> =>
    request.get(`/rest/products/search`, { params }),

  getViewed: (params?: any) =>
    request.get("/rest/product-histories/paginate", { params }),

  // singolo prodotto
  // UUID (legacy): /rest/products/:uuid
  getById: (uuid: string, params?: any): Promise<SuccessResponse<Product>> =>
    request.get(`/rest/products/${uuid}`, { params }),

  // **NUMERICO**: /rest/products/id/:id  --> quello che useremo nella pagina
  getByIdNumber: (id: number, params?: any): Promise<SuccessResponse<Product>> =>
    request.get(`/rest/products/id/${id}`, { params }),

  // bulk per ids (rimane com’è)
  getByIds: (params?: any): Promise<Paginate<Product>> =>
    request.get("/rest/products/ids", { params }),

  // alias temporaneo (deprecato)
  getByIdLegacyUuid: (uuid: string, params?: any) =>
    request.get<SuccessResponse<Product>>(`/rest/products/${uuid}`, { params }),
};

export default productService;
